import { FiltersModel } from '../filters';

export interface MoveFilterModel extends FiltersModel {
  status?: string;
  source_id?: number | string;
  destination_id?: number | string;
  type?: string;
}
